import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // ★ 추가

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// PWA 서비스워커 등록 (오프라인/설치 가능)
serviceWorkerRegistration.register(); // ★ 추가

reportWebVitals();
